import { InjectionToken } from '@angular/core';
import { DropdownOverlayData } from '@app/utils/interfaces/staff.interface';

export const OVERLAY_DATA = new InjectionToken<DropdownOverlayData>('OVERLAY_DATA');
